<script setup lang="ts">
import { CircleAlert, CircleCheck, Info, TriangleAlert, X } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';
import { useToastStore } from '@/stores/toasts';

const store = useToastStore();
const { t } = useI18n();

const icons = { info: Info, success: CircleCheck, warning: TriangleAlert, danger: CircleAlert };
</script>

<template>
  <div
    class="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex flex-col items-center gap-2 px-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:bottom-auto sm:top-4 sm:items-end"
    aria-live="polite"
    aria-atomic="false"
  >
    <TransitionGroup
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-2 opacity-0 sm:-translate-y-2"
      leave-active-class="transition duration-150 ease-in"
      leave-to-class="opacity-0"
    >
      <div
        v-for="toast in store.toasts"
        :key="toast.id"
        role="status"
        class="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-lg border border-border bg-surface p-3.5 text-sm text-fg shadow-3"
      >
        <component
          :is="icons[toast.tone]"
          class="mt-0.5 size-5 shrink-0"
          :class="{ info: 'text-primary', success: 'text-success', warning: 'text-warning', danger: 'text-danger' }[toast.tone]"
          aria-hidden="true"
        />
        <p class="min-w-0 flex-1 leading-snug">{{ toast.message }}</p>
        <button
          v-if="toast.action"
          type="button"
          class="shrink-0 rounded-md px-2 py-1 font-semibold text-primary hover:bg-primary-soft"
          @click="
            toast.action.run();
            store.dismiss(toast.id);
          "
        >
          {{ toast.action.label }}
        </button>
        <button
          type="button"
          class="-me-1 -mt-1 inline-flex size-8 shrink-0 items-center justify-center rounded-md text-fg-3 hover:bg-surface-2 hover:text-fg"
          :aria-label="t('common.close')"
          @click="store.dismiss(toast.id)"
        >
          <X class="size-4" aria-hidden="true" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
